module.exports = __webpack_public_path__ + "media/images/icons/favorites_white-23d0590e651757e80b2b559bd049135c.svg";